import React from 'react'
import './styles.css'
import BmwGroupLogo from '../../assets/images/bmw-group-logo.svg'
import { ContentContainer } from '../ContentContainer/ContentContainer'

const NavBar: React.FC = () => {
  return (
    <>
      <ContentContainer>
        <div className="navbar-component">
          <div className="navbar-left">
            <img className="brand-image" src={BmwGroupLogo} alt="BMW Group Logo" />
          </div>
        </div>
      </ContentContainer>
      <div className="header-line"></div>
    </>
  )
}

export default NavBar
